<template>
    <div class="data-page">
        <PageHeader :title="headerTitle" :subtitle="summaryText">
            <template #actions>
                <Button class="p-button-outlined" type="button" icon="pi pi-arrow-left" label="Voltar para clientes"
                    @click="goToClients" />
            </template>
        </PageHeader>

        <TabMenu class="data-tabs" :activeIndex="state.active" :model="state.items" @tab-change="goTo($event.index)"
            exact />

        <div v-if="state.loading.configurations" class="data-card data-form-loading">
            <ProgressSpinner />
        </div>

        <router-view v-else :configurations="state.configurations" :client="state.client"
            @realoadConfigurations="reloadConfigurations($event)" @goToRegisterClient="goTo(1)"></router-view>
    </div>
</template>

<script>
import { computed, reactive } from 'vue'
import { useRoute, useRouter } from 'vue-router'
import { useStore } from 'vuex'
import useNotificationToast from '../../../composables/useNotificationToast'
import services from '../../../services'
import PageHeader from '../../../components/PageHeader.vue'
import Button from 'primevue/button'
import TabMenu from 'primevue/tabmenu'
import ProgressSpinner from 'primevue/progressspinner'

export default {
    components: { PageHeader, Button, TabMenu, ProgressSpinner },

    setup() {

        const route = useRoute()

        const state = reactive({

            client: {},
            configurations: [],
            active: route.meta.tabMenuIndex,
            loading: {
                configurations: false,
            },
            items:
                [
                    {
                        label: 'Fornecedores',
                        icon: 'pi pi-fw pi-dollar',
                        routeName: 'client-configurations'
                    },
                    {
                        label: 'Registrar Fornecedores',
                        icon: 'pi pi-fw pi-plus',
                        routeName: 'register-configuration'
                    },
                    {
                        label: 'Gerenciar Endereços',
                        icon: 'pi pi pi-desktop',
                        routeName: 'manage-adresses'
                    }
                ]
        })

        const { success, error } = useNotificationToast()
        const router = useRouter()
        const store = useStore()

        const headerTitle = computed(() => state.client.name || 'Configurações do cliente')

        const summaryText = computed(() => {
            const total = state.configurations.length
            return `Cliente #${route.params.id} · ${total} ${total === 1 ? 'configuração cadastrada' : 'configurações cadastradas'}`
        })

        function reloadConfigurations(event) {

            if (event) {
                state.active = event.tabMenuIndex
                success(event.successMessage)
            }

            loadConfigurations()
        }

        loadConfigurations()

        function loadConfigurations() {

            state.loading.configurations = true

            const token = store.getters.getToken

            services.configurations.getConfigurationsClient({
                id: route.params.id,
                token
            }).then(({ data }) => {

                state.client = data.client
                state.configurations = data.configurations
                route.meta.readableName = `Configurações - ${state.client.name}`
                store.commit('updateStoredRoutes', {
                    currentRoute: {
                        fullPath: route.fullPath,
                        meta: route.meta
                    },
                    previousRoute: {
                        fullPath: '/clients',
                        meta: {
                            requiresAuth: true,
                            readableName: 'Clientes',
                            icon: 'pi pi-thumbs-up'
                        }
                    }
                })

            }).catch(() => {
                error('Não foi possível carregar as configurações do cliente.')
            }).finally(() => {
                state.loading.configurations = false
            })

        }

        function goTo(activeIndex) {

            state.active = activeIndex

            router.push({
                name: state.items[activeIndex].routeName
            })

        }

        function goToClients() {
            router.push({ name: 'Clients' })
        }

        return {
            state,
            headerTitle,
            summaryText,
            reloadConfigurations,
            loadConfigurations,
            goTo,
            goToClients
        }

    }
}
</script>
